import { ReactNode } from 'react';
import Container from '@v2/shared/components/Container';
import FaqAccordion from '@v2/shared/components/FaqAccordion';

const LINK_CLASS = 'text-red-600 underline hover:text-red-500 active:text-red-900';

/** The "view all titles" page, which is still headless_jshop's. */
const BROWSE_URL = '/categories/magzter-gold';

type Faq = {
  question: string;
  answer: ReactNode;
};

const FAQS: Faq[] = [
  {
    question: 'What is Magzter GOLD?',
    answer: (
      <p>
        DiscountMags has partnered with Magzter to offer their premium unlimited subscription, Magzter GOLD. Once you
        subscribe to Magzter GOLD, you can instantly access{' '}
        <a href={BROWSE_URL} className={LINK_CLASS}>
          over 10,000
        </a>{' '}
        digital magazines and newspapers on the Magzter platform.
      </p>
    ),
  },
  {
    question: 'What are the advantages of Magzter GOLD?',
    answer: (
      <p>
        Your subscription will allow you to access{' '}
        <a href={BROWSE_URL} className={LINK_CLASS}>
          10,000+
        </a>{' '}
        magazines and newspapers across 40+ exciting categories. Magzter GOLD&apos;s extensive catalog includes a wide
        variety of magazines that will suit anyone&apos;s interests. From sport to fashion, from food to culture, with
        everything in between.
      </p>
    ),
  },
  {
    question: 'Which titles are included?',
    answer: (
      <p>
        Magzter GOLD includes over 100,000 issues from{' '}
        <a href={BROWSE_URL} className={LINK_CLASS}>
          10,000+
        </a>{' '}
        digital magazines and newspapers. Visit our{' '}
        <a href={BROWSE_URL} className={LINK_CLASS}>
          available titles page
        </a>{' '}
        to browse all the available titles.
      </p>
    ),
  },
  {
    question: 'On which devices can I access Magzter GOLD?',
    answer:
      'You can enjoy reading anytime and anywhere on your desktop, laptop, iOS (Apple) and Android and Amazon devices.',
  },
  {
    question: 'What is your refund policy?',
    answer:
      "We're proud to offer a 7-Day No Questions Asked Refund Guarantee! Contact us within 7 days of your order and we'll provide you with 100% refund on your Magzter Gold subscription. After 7 days, no refunds will be provided; however you can cancel the renewal on the subscription anytime.",
  },
  {
    question: 'Can I cancel my subscription?',
    answer: (
      <p>
        Absolutely, there is no commitment and you can cancel your subscription anytime via your{' '}
        <a href="/customer?xCmd=account" className={LINK_CLASS}>
          account page
        </a>
        . If you are having trouble logging into your account, you can always{' '}
        <a href="/contact?xSubject=33" className={LINK_CLASS}>
          contact us
        </a>{' '}
        to request the cancellation.
      </p>
    ),
  },
  {
    question: 'Can I read offline?',
    answer: (
      <p>
        Yes! Using the Apple iOS, Amazon, or Android Magzter Gold apps, you can download specific issues to view offline
        when you don&apos;t have internet access.
        <br />
        <br />
        However, it is NOT possible to export or download the magazines to files outside of the apps.
      </p>
    ),
  },
  {
    question: 'Are back issues included?',
    answer: 'Yes, in fact, there are over 100,000 issues which include current and back issues.',
  },
  {
    question: 'Can I gift a subscription?',
    answer:
      'Absolutely and in fact its one of our most popular gift ideas. Just put the gift recipient\'s email address in the "Delivery" step of the checkout and they\'ll receive the Activation Email but not the Order Confirmation.',
  },
  {
    question: 'Do you have any more questions?',
    answer: (
      <p>
        Please visit our{' '}
        <a href="/help/magzter-gold" className={LINK_CLASS}>
          Magzter Gold Knowledge Center
        </a>{' '}
        for frequently asked questions or you may{' '}
        <a href="/contact?xSubject=33" className={LINK_CLASS}>
          contact our customer support
        </a>
      </p>
    ),
  },
];

export default function FaqPanel() {
  return (
    <div className="flex justify-center bg-slate-100 py-10 md:py-12 lg:py-20">
      <Container className="flex flex-col items-center justify-center">
        <h2 className="text-3xl md:text-4xl mb-10 font-bold text-center">Frequently Asked Questions</h2>
        {FAQS.map((faq) => (
          <FaqAccordion key={faq.question} question={faq.question} answer={faq.answer} className="mb-3" />
        ))}
      </Container>
    </div>
  );
}
